/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { BranchTyp } from 'src/app/_model/branch-types';

@Injectable()
export abstract class BranchTypesDaoService implements Resetable {
  public abstract saveBranchTypes(branchTypes: BranchTyp[]): Promise<void>;
  public abstract getBranchTypes(): Promise<BranchTyp[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
